import { snacks } from '@features/snackbar/store/snacks';
import type { SaleModel } from '../types';
import type { ValuesOf } from '@shared/types';
import { cropMsg } from '@entities/purchase';
import { SnackType } from '@features/snackbar';

export const handleSaleSuccess = () => {
  snacks.push({
    type: SnackType.Success,
    message: 'Your bid has been successfully placed',
  });
};

export const handleApproveSuccess = () => {
  snacks.push({
    type: SnackType.Success,
    message:
      'The transaction has been successfully approved. Please confirm one final transaction in your crypto wallet.',
  });
};

export const handleSaleError = (msg: string = 'Something went wrong. Please try again or contact support.') => {
  snacks.push({
    type: 'error',
    message: cropMsg(msg),
  });
};

export const SaleState = {
  Default: 'default',
  Loading: 'loading',
  ConnectWallet: 'connectWallet',
  SwitchChain: 'switchChain',
  Pending: 'pending',
  InProgress: 'inProgress',
  Error: 'error',
  Success: 'success',
  Approval: 'approval',
  Finalizing: 'finalizing',
} as const;

export type SaleState = ValuesOf<typeof SaleState>;

export const defaultData: SaleModel = {
  state: SaleState.Default,
};

export const saleStateTexts = {
  [SaleState.Default]: 'Place a bid',
  [SaleState.Loading]: 'Loading',
  [SaleState.ConnectWallet]: 'Connecting your wallet',
  [SaleState.SwitchChain]: 'Switching chain',
  [SaleState.Pending]: 'Waiting for transaction',
  [SaleState.InProgress]: 'Transaction in Progress',
  [SaleState.Error]: 'Try again',
  [SaleState.Success]: 'Waiting for data update',
  [SaleState.Approval]: 'Waiting for approval',
  [SaleState.Finalizing]: 'Auction is finalizing…',
} satisfies Record<SaleState, string>;

export const BID_UPDATE_INTERVAL_MS = 4000;
